/**
 * ImpersonationBanner — a persistent top bar shown app-wide while an admin is
 * viewing the app as another user. One click returns to the admin session.
 */

import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { VisibilityOff, Person } from '@mui/icons-material';
import { isImpersonating, impersonationInfo, stopImpersonation } from '../../utils/impersonation';

const ImpersonationBanner = () => {
  if (!isImpersonating()) return null;
  const info = impersonationInfo();

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (t) => t.zIndex.appBar + 2,
        bgcolor: '#1c1206',
        color: '#fff',
        px: 2,
        py: 0.75,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        borderBottom: '2px solid #C24E00',
      }}
    >
      <Person sx={{ fontSize: 18, color: '#FF7420' }} />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Viewing as <strong>{info?.name}</strong>. Actions are logged to the audit trail.
      </Typography>
      <Button
        size="small"
        variant="contained"
        startIcon={<VisibilityOff sx={{ fontSize: 16 }} />}
        onClick={stopImpersonation}
        sx={{ bgcolor: '#C24E00', textTransform: 'none', ml: 1, '&:hover': { bgcolor: '#9A3E00' } }}
      >
        Exit impersonation
      </Button>
    </Box>
  );
};

export default ImpersonationBanner;
